/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const UpsertAllowedOriginFormStatus = {
  Pending: "pending",
  Approved: "approved",
  Rejected: "rejected",
} as const;
export type UpsertAllowedOriginFormStatus = ClosedEnum<
  typeof UpsertAllowedOriginFormStatus
>;

export type UpsertAllowedOriginForm = {
  /**
   * The origin URL to upsert
   */
  origin: string;
  status?: UpsertAllowedOriginFormStatus | undefined;
};

/** @internal */
export const UpsertAllowedOriginFormStatus$outboundSchema: z.ZodMiniEnum<
  typeof UpsertAllowedOriginFormStatus
> = z.enum(UpsertAllowedOriginFormStatus);

/** @internal */
export type UpsertAllowedOriginForm$Outbound = {
  origin: string;
  status: string;
};

/** @internal */
export const UpsertAllowedOriginForm$outboundSchema: z.ZodMiniType<
  UpsertAllowedOriginForm$Outbound,
  UpsertAllowedOriginForm
> = z.object({
  origin: z.string(),
  status: z._default(UpsertAllowedOriginFormStatus$outboundSchema, "pending"),
});

export function upsertAllowedOriginFormToJSON(
  upsertAllowedOriginForm: UpsertAllowedOriginForm,
): string {
  return JSON.stringify(
    UpsertAllowedOriginForm$outboundSchema.parse(upsertAllowedOriginForm),
  );
}
